/* eslint-disable */
import data from '../../data/list-data.json'
import { transformedData } from '../FilterData'

class ScoreCalculator {
    constructor({
        importantWeights,
        switchWeights,
        scaleWeights,
        handWeights,
        coinWeights,
        whispersWeights,
        commanderWeights,
        grandMaesterWeights,
    }) {
        this.data = transformedData(data.data)
        this.importantWeights = importantWeights
        this.switchWeights = switchWeights
        this.scaleWeights = scaleWeights
        this.handWeights = handWeights
        this.coinWeights = coinWeights
        this.whispersWeights = whispersWeights
        this.commanderWeights = commanderWeights
        this.grandMaesterWeights = grandMaesterWeights
    }

    /* onUpdateCategory is used to assign new values to categories in specified child object. */
    onUpdateCategory(uiKey, uiValue, Weights) {
        const changedKey = Object.keys(this[Weights]).filter(key => key === uiKey)

        // Changes value from toggles to be numerical instead of boolean
        let newValue = null
        if (uiValue === true) {
            newValue = 1
        } else if (uiValue === false) {
            newValue = 0
        } else {
            newValue = uiValue
        }

        this[Weights] = { ...this[Weights], [changedKey]: newValue }
        this.update()
    }

    /* Gathers current weights and returns object to be used in xhr request */
    getSaveData() {
        const {
            importantWeights,
            switchWeights,
            scaleWeights,
            handWeights,
            coinWeights,
            whispersWeights,
            commanderWeights,
            grandMaesterWeights,
        } = this
        return {
            importantWeights,
            switchWeights,
            scaleWeights,
            handWeights,
            coinWeights,
            whispersWeights,
            commanderWeights,
            grandMaesterWeights,
        }
    }

    /* The following two methods uses magic to update the state in AppContext in componentDidMount */
    onUpdate(cb) {
        this.cb = cb
    }

    update() {
        if (typeof this.cb === 'function') {
            this.cb()
        }
    }

    /* Used to update input fields in ui components */
    getData(Weights) {
        return Object.assign({}, this[Weights])
    }

    /*
        Calculate scores using features and returns sorted list of titles and score.
    */

    calculateScore() {
        const {
            data,
            importantWeights,
            switchWeights,
            scaleWeights,
            handWeights,
            coinWeights,
            whispersWeights,
            commanderWeights,
            grandMaesterWeights,
        } = this

        const filteredDatabyImportantSwitch = data.filter(obj => {
            if (importantWeights.human === 0 && obj.featureImportant.human === 0) {
                return false
            }
            return true
        })

        // Remove data objects that aren't toggled on
        const filteredDataBySwitch = filteredDatabyImportantSwitch.filter(obj => {
            const keys = Object.keys(obj.featureSwitch)
            const filteredObject = keys.filter(key => {
                if (switchWeights[key] === 1 && obj.featureSwitch[key] === switchWeights[key]) {
                    return true
                }
                return false
            })
            return filteredObject.length > 0
        })

        if (filteredDataBySwitch.length < 6) {
            return false
        }

        // Calculate score from categories with values 0-10
        const calculateDataByScore = filteredDataBySwitch.map(obj => {
            const calcScore = Object.keys(obj.featureScale).reduce((acc, key) => (
                acc + (100 - Math.pow((scaleWeights[key] - obj.featureScale[key]), 2))
            ), 0)

            const handScore = Object.keys(obj.featureHand).reduce((acc, key) => (
                acc + (100 - Math.pow((handWeights[key] - obj.featureHand[key]), 2))
            ), 0)

            const coinScore = Object.keys(obj.featureCoin).reduce((acc, key) => (
                acc + (100 - Math.pow((coinWeights[key] - obj.featureCoin[key]), 2))
            ), 0)

            const whispersScore = Object.keys(obj.featureWhisper).reduce((acc, key) => (
                acc + (100 - Math.pow((whispersWeights[key] - obj.featureWhisper[key]), 2))
            ), 0)

            const commanderScore = Object.keys(obj.featureCommander).reduce((acc, key) => (
                acc + (100 - Math.pow((commanderWeights[key] - obj.featureCommander[key]), 2))
            ), 0)

            const grandMScore = Object.keys(obj.featureGrandM).reduce((acc, key) => (
                acc + (100 - Math.pow((grandMaesterWeights[key] - obj.featureGrandM[key]), 2))
            ), 0)

            return {
                ...obj,
                scores: {
                    handScore: Math.round((calcScore * .5 + handScore)),
                    coinScore: Math.round((calcScore * .5 + coinScore)),
                    whispersScore: Math.round((calcScore * .5 + whispersScore)),
                    commanderScore: Math.round((calcScore * .5 + commanderScore)),
                    grandMScore: Math.round((calcScore * .5 + grandMScore)),
                },
            }
        })

        // Sort list and create new array of objects with title and score
        let i = 0
        const sortPositionByScore = []
        while (i < 5) {
            const names = ['handScore', 'coinScore', 'whispersScore', 'commanderScore', 'grandMScore']
            const list = calculateDataByScore.map((obj, ind) => {
        
                const keyList = Object.keys(obj.scores)
                
                const hand = [{char: obj.character, url: obj.url, handScore: calculateDataByScore[ind].scores[keyList[0]]},
                {char: obj.character, url: obj.url, coinScore: calculateDataByScore[ind].scores[keyList[1]]},
                {char: obj.character, url: obj.url, whispersScore: calculateDataByScore[ind].scores[keyList[2]]},
                {char: obj.character, url: obj.url, commanderScore: calculateDataByScore[ind].scores[keyList[3]]},
                {char: obj.character, url: obj.url, grandMScore: calculateDataByScore[ind].scores[keyList[4]]},]
            
                return hand[i]
            }).sort((objA, objB) => objB[names[i]] - objA[names[i]])
                
            sortPositionByScore.push([list[0], list[1], list[2], list[3], list[4]])
            i++
        }
        
        // Sort array with highest to lowest overall scores
        const sortByPosition = sortPositionByScore.sort((objA, objB) => {
            const scoreValueA = Object.values(objA[0])
            const scoreValueB = Object.values(objB[0])
            return scoreValueB[1] - scoreValueA[1]
        })
        
        const sortByPositionNames = sortByPosition.map(obj => obj[0].char)
        const winnerNames = []

        // Checks for repeating names and returns final highest scores
        const finalList = sortByPosition.map((obj, k) => {
            if (winnerNames.indexOf(obj[0].char) === -1 && sortByPositionNames.indexOf(obj[0].char) >= k) {
                winnerNames.push(obj[0].char)
                return obj[0]
            }
            for (let j = 0; j <= winnerNames.length; j++) {
                if (winnerNames.indexOf(obj[j].char) === -1) {
                    winnerNames.push(obj[j].char)
                    return obj[j]
                }
            }
        })

        return finalList
    }
}

export default ScoreCalculator



// WEBPACK FOOTER //
// ./src/utils/calculator/ScoreCalculator.js